<template>
  <div class="myjfinprogress">
    <div class="content">
      <!-- 原始保单 -->
      <template v-if="productList.length > 0">
        <template v-for="(item) in productList">
          <ul v-for="(item2,index2) in item.pIL" :key="index2">
            <li class="product">
              <span class="title">{{item2.product}}</span>
              <span class="red">{{item2.cooperationMode == '1' ? '积分金额' : '宣传奖励'}}：￥{{item2.integral}}</span>
            </li>
            <li>保单号：{{item2.policyNo || '-'}}</li>
            <li>投保人：{{item2.accName || '-'}}</li>
            <li>投保时间：{{item2.issueDate || '-'}}</li>
            <li>出单用户：{{item2.agentName || '-'}}</li>
            <li>提现日期：{{item.withdrawDate || '-'}}</li>
            <!-- <li>未结算原因：{{item.noSettleReason || '-'}}</li> -->
          </ul>
        </template>
      </template>
      <div class="order_list_empty"
           v-else>
        无相关的数据
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/utils/api";
export default {
  data() {
    document.title = '结算中'
    return {
      userId: '',
      productList: []
    }
  },
  created() {
    this.userId = this.$route.query.userId
    this.queryIntegral();
  },
  methods: {
    // 切换Tab
    changeTab(item, index) {
      this.tabActiveIndex = index;
    },
    queryIntegral() {
      let params = {
        dateMonth: '',
        userId: this.userId,
        integralType: '2',
      }
      api.queryIntegral(params).then(res => {
        this.productList = res.data.content.withdrawRecordList || []
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.myjfinprogress {
  font-size: 12px;
  text-align: left;
  font-family: PingFangSC-Regular, PingFang SC;
  background: #fff;
  min-width: 100vw;
  min-height: 100vh;
  padding: 10px 18px;
  box-sizing: border-box;
  .content {
    .product {
      .red {
        color: #ff7c6d;
        font-size: 13px;
        vertical-align: bottom;
      }
    }
    .title {
      max-width: 170px;
      font-size: 15px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 21px;
    }
    ul {
      background: #f9f9f9;
      padding: 16px 18px;
      box-sizing: border-box;
      border-radius: 7px;
      margin-bottom: 15px;
      padding-bottom: 15px;
    }
    li {
      line-height: 17px;
      margin-bottom: 4px;
      font-size: 12px;
      color: #666;
    }
    li:last-child {
      margin-bottom: 0;
    }
    li:first-child {
      margin-bottom: 9px;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }
    .order_list_empty {
      font-size: 14px;
      margin-top: 80px;
      color: #666;
      text-align: center;
    }
  }
}
</style>